






import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component
export default class PdCreateInapp extends Vue {
  $store!: ExStore

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  async created() {
    await this.checkIsValidLogin()
    this.$store.dispatch('pd/setIsInAppBrowser', true)
    this.$router.replace({
      name: 'PdCreate'
    })
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      this.$store.dispatch('alert/showErrorMessages', ['エラーが発生しました'])
      this.$router.replace({ name: 'Hangup' })
    }
  }
}
